import { useState } from "react";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../../../Util/axios_helper";

const year = new Date().getFullYear().toString();
const initialState = {
  RevenuData: [],
  revenueDataLoaded: false,
  selectedMonth: [],
  refresh: 0,
  metrics: {
    type: "",
    filter: "",
    metrices: "",
    metricesValue: "",
  },
  year: year,
  MatrixDropVal: [],
  MatrixDropLoaded: false,
};

export const getRevenuData = createAsyncThunk("getRevenuData", async (obj) => {
  return await fetch(
    `Analytics/Get_RevenueData?type=${obj.type}&years=${obj.years}&filter=${obj.filter}&metrics=${obj.metrics}&value=${obj.value}`
  );
});

export const getMatrixDropValue = createAsyncThunk(
  "getMatrixDropValue",
  async (obj) => {
    return await fetch(`Analytics/Get_DashboardDropValue`);
  }
);

const revenuSlice = createSlice({
  name: "Revenue",
  initialState: initialState,
  reducers: {
    changeType: (state, data) => {
      state.metrics = data.payload;
      state.refresh = state.refresh + 1;
    },
    changeYear: (state, data) => {
      state.year = data.payload;
      state.refresh = state.refresh + 1;
    },
  },
  extraReducers: (builder) => {
    //revenue
    builder.addCase(getRevenuData.pending, (state) => {
      state.revenueDataLoaded = false;
    });

    builder.addCase(getRevenuData.fulfilled, (state, data) => {
      state.revenueDataLoaded = true;
      state.RevenuData = data.payload;
    });

    builder.addCase(getRevenuData.rejected, (state, data) => {
      state.revenueDataLoaded = true;
      state.RevenuData = null;
    });
    builder.addCase(getMatrixDropValue.pending, (state) => {
      state.MatrixDropLoaded = false;
    });

    builder.addCase(getMatrixDropValue.fulfilled, (state, data) => {
      state.MatrixDropLoaded = true;
      state.MatrixDropVal = data.payload;
    });

    builder.addCase(getMatrixDropValue.rejected, (state) => {
      state.MatrixDropLoaded = true;
      state.MatrixDropVal = null;
    });
  },
});

export const { changeType, changeYear } = revenuSlice.actions;
export default revenuSlice.reducer;
